import { QueryKey, UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'

import { frontmanState } from '@/atoms/frontmanState'

function useQueryWrapper<TQueryFnData, TError, TData = TQueryFnData>(
  queryKey: QueryKey,
  queryFn: () => Promise<TQueryFnData>,
  options?: UseQueryOptions<TQueryFnData, TError, TData>
): UseQueryResult<TData, TError> {
  const { isInitialized } = useAtomValue(frontmanState)
  const { enabled, ...restOptions } = options || {}
  const isEnabled = isInitialized && enabled

  return useQuery<TQueryFnData, TError, TData>(queryKey, queryFn, {
    enabled: isEnabled,
    ...restOptions,
  })
}

export { useQueryWrapper }
